// extracted by mini-css-extract-plugin
export default {"icon":"GreenLinkRow_icon__61TeF","title":"GreenLinkRow_title__xpDGy","placeHolderShimmer":"GreenLinkRow_placeHolderShimmer__Jovsh"};